import React from "react";
import { AuthenticationWrapper } from "./context/Authentication/AuthenticationContext";
import Router from "./routes/Router";
import { Helmet } from "react-helmet";
import logoText from "./assets/images/logo/Sabadi.png";
import withClearCache from "./hoc/WithClearCache";
import { ShoppingCartItemProvider } from "./context/ShoppingCart/ShoppingCartItemContext";
import { ScrollToTop } from "react-router-scroll-to-top";
import { Toaster } from "react-hot-toast";
import ReactGA from "react-ga";

const ClearCacheComponent = withClearCache(MainApp);

function App() {
  return <ClearCacheComponent />;
}

function MainApp() {
  // sabadi
  const TRACKING_ID = "UA-235207325-1";
  // fazeli
  // const TRACKING_ID = "UA-263382959-1";
  ReactGA.initialize(TRACKING_ID);
  return (
    <div className="App">
      <Helmet>
        <title>سبدی</title>
      </Helmet>
      {/* <ScrollToTop /> */}
      <AuthenticationWrapper>
        <Toaster />
        <ShoppingCartItemProvider>
          <Router />
          <div id="fixed-items" />
        </ShoppingCartItemProvider>
      </AuthenticationWrapper>
    </div>
  );
}

export default App;
